

























import { Vue, Component } from "vue-property-decorator";
import { Calendar } from "vant";

import bottonBar from "@/components/bottonBar.vue";

@Component({
  components: {
    [Calendar.name]: Calendar,
    bottonBar,
  },
})
export default class extends Vue {
  get serveType(): string {
    return this.$route.query.serve as string;
  }
  get service(): string {
    return this.serveType + "Info";
  }
  //mounted
  mounted() {}
  // methods
  back(): void {
    history.back();
  }
}
